module.exports = __webpack_public_path__ + "static/media/shareholder.c9bade77.png";